<template>
  <div class="overlay">
    <div class="sub-tarefa-inputs">
      <div class="modal-header">
        <span class="modal-label">confirmação</span>
        <h6 class="btn-fechar-modal" @click="fecharModal()">
          ×
        </h6>
      </div>
      <div class="modal-corpo">
        <i class="fa-solid fa-circle-question fa-3x" style="color: var(--roxo-primario)">
        </i>

        <h4>{{ texto }}</h4>
        <div class="btns">
          <button type="button" class="sub-tarefa-btn" @click="confirmacaoFuncao(true)">
            Sim
          </button>
          <button type="button" class="sub-tarefa-btn" @click="confirmacaoFuncao(false)">
            Não
          </button>
          <!-- <div
            class="subTarefa-titulo-input subTarefa-titulo-input-aviso"
            v-if="sucesso == true"
          >
            <i
              class="fa-solid fa-circle-check fa-5x"
              style="color: #27d41b"
            ></i>
            <h4>{{ texto }}</h4>
          </div>
          <div
            class="subTarefa-titulo-input subTarefa-titulo-input-aviso"
            v-if="sucesso == false"
          >
            <i
              class="fa-sharp fa-solid fa-circle-exclamation fa-5x"
              style="color: var(--vermelho)"
            ></i>
            <h4>{{ texto }}</h4>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  texto: String,
});
const confirmacao = ref(false);
const emit = defineEmits(["confirmacao"]);
function confirmacaoFuncao(valor) {
  confirmacao.value = valor;
  fecharModal();
}
function fecharModal() {
  emit("confirmacao", confirmacao.value);
}
</script>

<style scoped>
.sub-tarefa-btn {
  padding: 8px 25px;
  background-color: var(--roxo-primario);
  color: var(--branco);
  border-radius: 5px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
}

.sub-tarefa-btn:hover {
  background-color: var(--roxo-medio);
}

.sub-tarefa-inputs {
  border: none;
  border-radius: 12px;
  width: 600px;
  max-width: 90vw;
  max-height: 90vh;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.sub-tarefa-inputs-top {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: var(--roxo-primario);
  border-radius: 15px 15px 0 0;
  padding: 15px 0;
  position: relative;
  min-height: 50px;
}

.sub-tarefa-inputs-top h6:first-child {
  color: var(--branco);
  font-weight: bold;
  margin: 0;
  text-align: center;
}

.sub-tarefa-inputs-top h6:last-child {
  position: absolute;
  top: 0;
  right: 0;
  padding: 3px 30px;
  border-radius: 0px 15px 0px 0px;
  background-color: var(--vermelho-escuro);
  color: var(--branco);
  margin: 0;
  cursor: pointer;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 100%;
}

.sub-tarefa-inputs-top h6:last-child:hover {
  background-color: var(--vermelho);
}

.sub-tarefa-all-inputs {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.modal-corpo {
  text-align: center;
  background: var(--branco);
}

h4 {
  font-size: 1rem;
  margin-top: 0.5rem;
  text-align: center;
  margin-bottom: 0;
}

.btns {
  display: flex;
  flex-direction: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 1rem;
}

.subTarefa-titulo-input-aviso {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
